import React from "react";
import Image from "next/image";

const FeatureItem = ({ label, icon }) => {
  return (
    <div className="flex items-center gap-2 py-2 px-3 rounded-[38px] border border-[#E7EDF4] bg-white">
      <Image
        src={"/icons/check.svg"}
        width={12}
        height={12}
        alt={label}
        className="object-contain"
      />
      <span className="text-[#757C7F] text-xs font-medium leading-normal">
        {label}
      </span>
    </div>
  );
};

export default FeatureItem;
